export interface ReportRecipientContactPerson {
  id: number;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  job_title?: string | null;
}

export interface ReportRecipientSource {
  contact_person_id?: number | string | null;
  contact_person?: string | null;
  contact_name?: string | null;
  contact_email?: string | null;
}

export interface DefaultReportRecipient {
  selectedContactId: number | 'other' | 'none';
  email: string;
  name: string;
}

const normalizeContactValue = (value?: string | null) => value?.trim().toLowerCase() || '';

export const getReportRecipientPersonName = (person: ReportRecipientContactPerson): string => {
  return `${person.first_name || ''} ${person.last_name || ''}`.trim();
};

export function resolveDefaultReportRecipient(
  workItem: ReportRecipientSource,
  contactPeople: ReportRecipientContactPerson[] = [],
): DefaultReportRecipient {
  const matchedSelectedPerson = workItem.contact_person_id != null
    ? contactPeople.find((person) => Number(person.id) === Number(workItem.contact_person_id))
    : undefined;

  const normalizedContactPersonName = normalizeContactValue(workItem.contact_person);
  const matchedSelectedPersonByName = !matchedSelectedPerson && normalizedContactPersonName
    ? contactPeople.find(
        (person) => normalizeContactValue(getReportRecipientPersonName(person)) === normalizedContactPersonName,
      )
    : undefined;

  const matchedPerson = matchedSelectedPerson || matchedSelectedPersonByName;

  if (matchedPerson) {
    return {
      selectedContactId: matchedPerson.id,
      email: matchedPerson.email?.trim() || '',
      name: getReportRecipientPersonName(matchedPerson),
    };
  }

  const fallbackName = workItem.contact_person?.trim() || workItem.contact_name?.trim() || '';
  const fallbackEmail = workItem.contact_email?.trim() || '';

  if (fallbackName || fallbackEmail) {
    return {
      selectedContactId: 'other',
      email: fallbackEmail,
      name: fallbackName,
    };
  }

  return {
    selectedContactId: contactPeople.length > 0 ? 'none' : 'other',
    email: '',
    name: '',
  };
}